<template>
  <generic-modal :title="$t('profile')" ref="generic_modal" :is_wide="true">
    <form>
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("name") }}</label>
            <div class="control">
              <input
                type="text"
                class="input"
                v-model="meta.name"
                :placeholder="$t('name')"
              />
            </div>
          </div>
        </div>
        <div class="column" v-if="meta.settings">
          <div class="field">
            <label class="label">{{ $t("provider") }}</label>
            <div class="control">
              <div class="select is-fullwidth">
                <select v-model="meta.settings.provider">
                  <option value="">{{ $t("select provider") }}</option>
                  <option value="bitly">Bit.ly</option>
                  <option value="shortio">Short.io</option>
                  <!-- <option value="tinyurl">TinyURL</option>
                  <option value="rebrandly">Rebrandly</option>
                  <option value="custom">{{ $t("custom") }}</option> -->
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="columns" v-if="meta.settings">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("domain") }}</label>
            <p class="control is-expanded has-icons-left">
              <input
                type="text"
                class="input"
                v-model="meta.settings.domain"
                :placeholder="$t('domain')"
              />
              <span class="icon is-small is-left">
                <i class="fa fa-globe"></i>
              </span>
            </p>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("api key") }}</label>
            <p class="control is-expanded has-icons-left">
              <input
                type="text"
                class="input"
                v-model="meta.settings.api_key"
                :placeholder="$t('api key')"
              />
              <span class="icon is-small is-left">
                <i class="fa fa-key"></i>
              </span>
            </p>
          </div>
        </div>
      </div>

      <div class="columns" v-if="meta.settings">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("api url") }}</label>
            <p class="control is-expanded has-icons-left">
              <input
                type="text"
                class="input"
                v-model="meta.settings.api_url"
                :placeholder="$t('api url')"
              />
              <span class="icon is-small is-left">
                <i class="fa fa-server"></i>
              </span>
            </p>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("options") }}</label>
            <input
              class="is-checkradio"
              type="checkbox"
              id="chk_is_active"
              v-model="meta.settings.is_active"
            />
            <label for="chk_is_active">{{ $t("is active") }}</label>
          </div>
        </div>
      </div>

      <div class="field" v-if="meta.settings">
        <label class="label">{{ $t("description") }}</label>
        <div class="control">
          <textarea
            class="textarea"
            v-model="meta.settings.description"
            :placeholder="$t('description')"
          ></textarea>
        </div>
      </div>
    </form>

    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>

    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>

<script>
import { put, post, get, generate_error_message_text } from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";

export default {
  name: "ProfileModal",
  components: { GenericModal },
  props: {},
  data() {
    return {
      meta: {},
      error: "",
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      return (
        !v.meta.name ||
        !v.meta.settings ||
        !v.meta.settings.provider ||
        !v.meta.settings.domain
      );
    },
  },
  methods: {
    close_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.close_modal();
    },
    show_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.show_modal();
    },
    edit_modal(profile_uuid) {
      let v = this;
      v.set_initial_state();
      v.$root.loader(true);
      get("/shortlink/profile", { uuid: profile_uuid })
        .then((profile) => {
          v.meta = profile;
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        })
        .finally(() => v.$root.loader(false));
      v.$refs.generic_modal.show_modal();
    },
    save() {
      let v = this;
      let profile = { ...v.meta };
      v.$root.loader(true);
      if (profile.uuid) {
        post("/shortlink/profile", profile)
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          })
          .finally(() => v.$root.loader(false));
      } else {
        put("/shortlink/profile", profile)
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          })
          .finally(() => v.$root.loader(false));
      }
    },
    set_initial_state() {
      let v = this;
      v.meta = {
        name: "",
        settings: {
          provider: "",
          domain: "",
          api_key: "",
          api_url: "",
          description: "",
          is_active: true,
        },
      };
      v.error = "";
    },
  },
  mounted() {},
};
</script>

<style></style>
